import { useState } from "react"
import { loginUser, logout, searchClientByCode } from "services/actions/userAction"
import { useForm } from "react-hook-form"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom";
import md5 from "md5";
import { useUtil } from "hooks/Utils/useUtil";

export const useLogin = (toast) => {

	const dispatch = useDispatch()
	const history = useHistory()
	const [ isLoading, setIsLoading ] = useState(false)
	const [ listCodeInternal, setListCodeInternal ] = useState(false)
	const { register, handleSubmit, errors, control, setError, getValues } = useForm()
	const { userData } = useSelector((state) => state.users)
	const [ searchClient, setSearchClient ] = useState(0)

	const { handleBlurRut, shown, switchShown  } = useUtil(toast)
	

	const onSubmit = async (data, event) => {
		try{
			setIsLoading(true)
			if(searchClient===0){
				toast.error("Espere unos segundos mientras se valida el RUT", {position: toast.POSITION.TOP_RIGHT})
				setIsLoading(false)
				return false
			}
			let body = {
				rut: data.rut,
				password: md5(data?.password),
				code_internal: data?.codigo_interno ?? ""
			}

			let response = await dispatch(loginUser(body))
			
			setIsLoading(false)

			if(response.status){
				toast.success(response.message, {position: toast.POSITION.TOP_RIGHT})
				setSearchClient(0)
				history.push('/paquetes')
			}else{
				toast.error(response.message, {position: toast.POSITION.TOP_RIGHT})
				return false
			}

		}catch(error){
			toast.error("Hubo un error, intentelo nuevamente", {position: toast.POSITION.TOP_RIGHT})
			return false
		}
	}

	const logoutUser = async (event) => {
		event.preventDefault()
		const response = await dispatch(logout())
		if(response.status){
			history.push('/')
            window.location.reload()
		}
	}

	const handleSearchClientByCode = async (event) => {
		event.preventDefault()

		handleBlurRut(event, setError);
	
		if(errors?.rut?.message===""){
			const body = {
				rut: getValues()?.rut
			}
			const response = await dispatch(searchClientByCode(body));
	
			setListCodeInternal(response?.data)
			setSearchClient(1)
			
		}
	}
	

	const formElement = {
		onSubmit,
		register, 
		handleSubmit, 
		errors,
		control,
		setError
	}

	const state = {
		isLoading,
		userData,
		switchShown, 
		shown,
		listCodeInternal
	}

	const actions = {
		logoutUser,
		handleSearchClientByCode,
		setSearchClient
	}

	return {
		formElement,
		state,
		actions
	}
}